export type ResolutionBreakpoint = 600 | 960 | 1280 | 1920;

export const ResolutionBreakpoints = [600, 960, 1280, 1920];
export const Signs = [">", "<", ">=", "<="];